// These names match the eager shared stylesheet imported by global-rules.css.
const styles = {
  sheet: 'ht-nav-sheet',
  cream: 'ht-nav-sheet-cream',
  dark: 'ht-nav-sheet-dark',
  scrim: 'ht-nav-sheet-scrim',
  scrimDark: 'ht-nav-sheet-scrim-dark',
  noScrollbar: 'ht-nav-sheet-no-scrollbar',
  screenForward: 'ht-nav-sheet-screen-forward',
  screenBack: 'ht-nav-sheet-screen-back',
} as const

export default styles
